export const blockIconsCommunicationAlternateEmailNew = (
	<span className='material-symbols-outlined'>alternate_email</span>
);
